export default function isNumber(value: any) {
  if (value === null || value === undefined) {
    return false;
  }

  return !Number.isNaN(value) && !Number.isNaN(parseFloat(value));
}
